import { ContentCopy } from '@mui/icons-material'
import { Button, Tooltip } from '@mui/material'
import { useHistory } from 'react-router-dom'

import { Roles } from 'constants/EntityConstants/Roles'
import { Paths } from 'constants/index'
import { GetBookingQuery, GetUserBookingQuery } from 'generated/graphql'
import { useUserRole } from 'hooks/useUserRole'

interface IProps {
  bookingDetails?: GetBookingQuery['booking'] | GetUserBookingQuery['userBooking']
}

const CustomerCopyButton = (props: IProps) => {
  const { bookingDetails } = props
  const history = useHistory()
  const currentUserRole = useUserRole()

  if (currentUserRole !== Roles.customer || !bookingDetails?.id) {
    return null
  }

  const handleCopyClick = () => {
    history.push({
      pathname: Paths.quotes.create,
      search: `?copyFrom=${bookingDetails.id}`,
    })
  }

  return (
    <Tooltip title='Copy' arrow>
      <Button
        variant='contained'
        color='grey'
        startIcon={<ContentCopy />}
        onClick={handleCopyClick}>
        Copy
      </Button>
    </Tooltip>
  )
}

export default CustomerCopyButton
